import React from 'react';
import {Box, Button, Flex, Image, Link, Spacer} from '@chakra-ui/react';

import { useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import useMediaQuery from "./hooks/useMediaQuery";

const Link2 = ({ page, selectedPage, setSelectedPage }) => {
    const lowerCasePage = page.toLowerCase();
    return (
      <AnchorLink
        className={`${
          selectedPage === lowerCasePage ? "text-yellow" : ""
        } hover:text-yellow transition duration-500`}
        href={`#${lowerCasePage}`}
        onClick={() => setSelectedPage(lowerCasePage)}
      >
        {page}
      </AnchorLink>
    );
  };



const NavBar = ({ accounts, setAccounts, isTopOfPage, selectedPage, setSelectedPage}) => {
    const [isMenuToggled, setIsMenuToggled] = useState(false);
    const isDesktop = useMediaQuery("(min-width: 768px)");
    const navbarBackground = isTopOfPage ? "" : "bg-deep-blue";
   


    return (
        <nav className={`${navbarBackground} w-full fixed `}>
        <Flex justify = "space-between" align = "center" padding = "10px 10px 10px">
        
            { /* left side Social media Icons*/ }   

            {/*Right Side - Sections and connect*/ }
            <Flex
                justify = "space-around"
                align = "center"
                //width = "40%"
                //padding = "30px"
            >
            <a
            className="hover:opacity-50 transition duration-500"
            href="https://mobile.twitter.com/nervedrip"
            target="_blank"
            rel="noreferrer"
          >
            <img alt="kascade-link" src="../assets/kascade-Circ-LogoTB-StylizedBWFavicon.png" />
          </a>
            <h4 //className=" rounded-full bg-deep-blue before:content-kascadeLogo" 
            >
                
            </h4>
          
            {/* DESKTOP NAV */}

            </Flex>
            <Flex
                justify = "space-around"
                align = "center"
                //width = "40%"
                paddingLeft = "120px"
                paddingRight = "80px"
            >
            </Flex>
            

            {/* Connect */}
                <div className="flex justify-between mx-auto">
                    
                        
                    {/* MOBILE MENU POPUP */}
                    {!isDesktop && isMenuToggled && (
                    <div className="fixed left-0 bottom-0 h-full bg-blue w-[300px]">
                        {/* CLOSE ICON */}
                        <div className="flex justify-end p-14">
                        <button onClick={() => setIsMenuToggled(!isMenuToggled)}>
                            <img alt="close-icon" src="../assets/close-icon.svg" />
                        </button>
                        </div>

                        {/* MENU ITEMS */}
                        <div className="flex flex-col gap-10 ml-[33%] text-2xl text-deep-blue">
                        <Link2
                            page="Mint"
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                        <Link2
                            page="Rupture"
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                        <Link2
                            page="RoadMap"
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />

                        <Link2
                            page="Contact"
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                        </div>
                    </div>
                    )}

                </div>


          
        </Flex>
        </nav>
        

        
    );
};

export default NavBar;

